import Header from "./Header";
import DocumentView from "../expedient/DocumentView";

export default function LayoutDocument() {
  
  return (
    <>
      <Header />
      <DocumentView />
    </>
  );
}
